import MemberListPage from './Component/MemberListPage';
import memberRoleConfig from './memberRoleConfig';

const OwnersPage = () => <MemberListPage roleConfig={memberRoleConfig.owner} />;

export default OwnersPage;
